import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router'

const CookieBanner = () => {
  const history = useHistory()
  const [showBanner, setShowBanner] = useState(
    localStorage.getItem('cookiesAccepted') !== 'true',
  );
  const modalClose = useRef<any>()

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowBanner(false);
  };

  const toPrivacyStatement = (e: any) => {
    try {
      e.preventDefault()
      history.push('/privacystatement')
    } catch (e) { console.log(e) }
  }

  // useEffect(() => {
  //   if (showBanner) {
  //     document.body.classList.add('modal-open');
  //   } else {
  //     document.body.classList.remove('modal-open');
  //   }
  // }, [showBanner]);

  if (!showBanner) {
    return null;
  }
  const currentUrl = window.location.href;
  const isPrivacyPolicy = currentUrl.includes('/privacystatement') //|| currentUrl.includes('/confirm_password')

  if (isPrivacyPolicy) {
    return null;
  }

  return (
    <>
      <div className="modal-backdrop show" />
      <div className="modal fade show" id="cookie-modal" style={{ opacity: 1 }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Cookies</h5>
            </div>
            <div className="modal-body cart-addon">
              <p>We gebruiken cookies om uw ervaring op onze website te verbeteren. Door op &quot;Accepteren&quot; te
                klikken, stemt u in met het gebruik van alle cookies. U kunt echter
                naar &quot;Cookie-instellingen&quot; gaan om te kiezen welke cookies u wilt toestaan.

                We gebruiken alleen lokale opslag voor functionele doeleinden, zoals het onthouden van uw
                winkelwagen-items en inloggegevens, en we slaan verkoopgegevens en profielgegevens op in een beveiligde
                database. We delen geen van uw informatie met derden. Voor meer informatie over hoe we cookies gebruiken
                en hoe we uw privacy beschermen, raadpleegt u ons <a onClick={toPrivacyStatement} style={{ cursor: 'pointer', color: 'red' }}>Privacybeleid</a>.

                Bedankt dat u voor HappyOrder heeft gekozen. Geniet van uw maaltijd!
              </p>

            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn theme-btn"
                ref={modalClose}
                data-dismiss="modal"
                onClick={handleAccept}
              >
                Accepteren
              </button>
            </div>
          </div>
      </div>
    </>
  );
};

export default CookieBanner;
